/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Approvals_Empty_TitleInputs */



/**
* | output |
* | --- |
* | "Nothing is waiting for your approval" |
*
* @param {Agent_Approvals_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_approvals_empty_title = /** @type {((inputs?: Agent_Approvals_Empty_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Approvals_Empty_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nichts wartet auf Ihre Freigabe")
	return /** @type {LocalizedString} */ ("Nothing is waiting for your approval")
});